{
  "loading": "Ładowanie...",
  "placeholder": "Wybierz opcję..."
}
